import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import store from './reducers/store'
import init from './init'

import Nav from './Nav';

import registerServiceWorker from './registerServiceWorker';

import 'foundation-sites/dist/css/foundation.min.css'
import './style.css'

document.title = 'Identical Faces'

init()

const Root = (props) => (
    <Provider store={store}>
        <Nav />
    </Provider>
)

ReactDOM.render(<Root />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js